import React, { MouseEvent } from "react"
import { useForm } from "react-hook-form"
import axios, { AxiosRequestConfig } from "axios"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import styles from "../styles/pages/join.module.scss"
import Ethan from "../images/fallbacks/ethan.jpg"
import Brenda from "../images/fallbacks/brenda.jpg"
import EthanSmall from "../images/fallbacks/ethan-small.jpg"
import BrendaSmall from "../images/fallbacks/brenda-small.jpg"
import EthanWebp from "../images/webp/ethan.webp"
import BrendaWebp from "../images/webp/brenda.webp"
import EthanWebpSmall from "../images/webp/ethan-small.webp"
import BrendaWebpSmall from "../images/webp/brenda-small.webp"

const JoinUs = () => {
  const { register, handleSubmit, watch, reset, errors, getValues } = useForm()

  const submitHandler = (values: any, e: any) => {
    const formData = new FormData(e.target)

    const options: AxiosRequestConfig = {
      method: "POST",
      url: "http://localhost:5001/jenga-site/us-central1/sendJoinEmail/join",
      headers: {
        "Content-Type": "multipart/form-data",
        "content-type":
          "multipart/form-data; boundary=---011000010111000001101001",
      },
      data: formData,
    }

    axios
      .request(options)
      .then(function (response) {
        console.log(response.data)
      })
      .catch(function (error) {
        console.error(error)
      })
  }

  return (
    <Layout>
      <SEO title="Home" />
      <section className={styles.heroWrapper}>
        <div className={styles.hero}>
          <h2 className={styles.heroTitle}>Grow as a Developer</h2>
          <p className={styles.heroSubtitle}>
            Augment your tech team &amp; Accelerate your growth with the top 1%
            of Kenya’s developers
          </p>
          <button className={styles.heroBtn}>Hire Developers</button>
        </div>
      </section>
      <section className={styles.testimonialsWrapper}>
        <div className={styles.testimonials}>
          <h2 className={styles.testimonialsTitle}>Working at Jenga</h2>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="27.88"
            viewBox="0 0 30 27.88"
            className={styles.testimonialsIcon}
          >
            <g>
              <path
                fill="currentColor"
                d="M12.917 13.562v5.006a1.229 1.229 0 0 1-1.229 1.232c-2.422 0-3.74 2.484-3.923 7.388h3.923a1.229 1.229 0 0 1 1.229 1.229v10.57a1.229 1.229 0 0 1-1.229 1.229H1.229A1.229 1.229 0 0 1 0 38.984v-10.57A27.106 27.106 0 0 1 .7 22a15.428 15.428 0 0 1 2.183-5.075A10.655 10.655 0 0 1 6.6 13.538a10.557 10.557 0 0 1 5.093-1.205 1.229 1.229 0 0 1 1.224 1.229zM28.771 19.8A1.23 1.23 0 0 0 30 18.568v-5.006a1.229 1.229 0 0 0-1.229-1.229 10.209 10.209 0 0 0-8.8 4.595A15.435 15.435 0 0 0 17.786 22a27.126 27.126 0 0 0-.7 6.412v10.57a1.229 1.229 0 0 0 1.229 1.229h10.456A1.229 1.229 0 0 0 30 38.984v-10.57a1.229 1.229 0 0 0-1.229-1.229H24.9c.184-4.903 1.482-7.385 3.871-7.385z"
                transform="translate(0 -12.333)"
              />
            </g>
          </svg>
          <div className={styles.testimonialsCard}>
            <p className={styles.testimonialsCardText}>
              I started by two weeks of training to ramp up on a language and a
              framework I wasn’t fluent in. By week 3, I was a fully integrated
              team member in the tech team of a French AI start-up, developing
              the application their clients will use all across the globe.
            </p>
            <div className={styles.testimonialsCardDev}>
              <picture className={styles.testimonialsCardImg}>
                <source srcSet={EthanSmall} media="(max-width: 700px)" />
                <source srcSet={EthanWebpSmall} media="(max-width: 700px)" />
                <source srcSet={EthanWebp} media="(min-width: 701px)" />
                <source srcSet={Ethan} media="(min-width: 701px)" />
                <img src={Ethan} alt="Jenga Developer" />
              </picture>
              <div>
                <h3>Ethan</h3>
                <p>
                  Bachelor of Business Information Technology Graduate,
                  Strathmore University
                </p>
              </div>
            </div>
          </div>
          <div className={styles.testimonialsCard}>
            <p className={styles.testimonialsCardText}>
              Mock projects were great to learn the basics, and then I joined
              Jenga where I am developing real solutions for real organizations
              with a real impact!
            </p>
            <div className={styles.testimonialsCardDev}>
              <picture className={styles.testimonialsCardImg}>
                <source srcSet={BrendaSmall} media="(max-width: 700px)" />
                <source srcSet={BrendaWebpSmall} media="(max-width: 700px)" />
                <source srcSet={BrendaWebp} media="(min-width: 701px)" />
                <source srcSet={Brenda} media="(min-width: 701px)" />
                <img src={Brenda} alt="Jenga Developer" />
              </picture>
              <div>
                <h3>Brenda</h3>
                <p>Graduate, Moringa School</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.contactWrapper}>
        <div className={styles.contact}>
          <h2 className={styles.contactTitle}>
            Apply to be a{" "}
            <span className={styles.contactTitleEmphasis}>
              Junior Software Developer
            </span>
          </h2>

          <div className={styles.contactForm}>
            <h3 className={styles.contactFormTitle}>Contact Us</h3>
            <form
              className={styles.form}
              onSubmit={handleSubmit(submitHandler)}
            >
              <div className={styles.formGroup}>
                <label htmlFor="nameID" className={styles.formLabel}>
                  Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  id="nameID"
                  placeholder="Name"
                  className={styles.formControl}
                  ref={register({
                    required: "This field is required",
                  })}
                />
                <small className={styles.formError}>
                  {errors.fullName?.message}
                </small>
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="emailID" className={styles.formLabel}>
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="emailID"
                  placeholder="Email"
                  className={styles.formControl}
                  ref={register({
                    required: "This field is required",
                  })}
                />
                <small className={styles.formError}>
                  {errors.email?.message}
                </small>
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="githubLinkID" className={styles.formLabel}>
                  <span>Github Link</span>
                  <span>optional</span>
                </label>
                <input
                  type="text"
                  name="githubLink"
                  id="githubLinkID"
                  placeholder="Github Link"
                  className={styles.formControl}
                  ref={register}
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="LinkedInID" className={styles.formLabel}>
                  <span>Linkedin Profile Link</span>
                  <span>optional</span>
                </label>
                <input
                  type="text"
                  name="linkedinLink"
                  id="LinkedInID"
                  placeholder="Linkedin Profile Link"
                  className={styles.formControl}
                  ref={register}
                />
              </div>

              <div className={styles.formGroup}>
                <p className={styles.formCustomUploadLabel}>Resume</p>
                <div>
                  <label htmlFor="resumeID" className={styles.formCustomUpload}>
                    <span>
                      {watch("resume") &&
                      watch("resume")[0] &&
                      watch("resume")[0].name.length > 0 ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                          </svg>
                          <p>{watch("resume")[0].name}</p>
                        </div>
                      ) : (
                        "Upload file"
                      )}
                    </span>
                  </label>
                  <input
                    type="file"
                    name="resume"
                    accept=".pdf,.docx"
                    id="resumeID"
                    className={styles.formCustomUploadInput}
                    ref={register({
                      required: "Please upload a file",
                    })}
                  />
                </div>
                <small className={styles.formError}>
                  {errors.resume?.message}
                </small>
              </div>

              <div className={styles.formGroup}>
                <p className={styles.formCustomUploadLabel}>
                  <span>Cover Letter</span>
                  <span>optional</span>
                </p>

                <div>
                  <label
                    htmlFor="coverLetterID"
                    className={styles.formCustomUpload}
                  >
                    <span>
                      {watch("coverLetter") &&
                      watch("coverLetter")[0] &&
                      watch("coverLetter")[0].name.length > 0 ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                          </svg>
                          <p>
                            {watch("coverLetter") &&
                              watch("coverLetter")[0].name}
                          </p>
                        </div>
                      ) : (
                        "Upload file"
                      )}
                    </span>
                  </label>
                  <input
                    type="file"
                    name="coverLetter"
                    accept=".pdf,.docx"
                    id="coverLetterID"
                    className={styles.formCustomUploadInput}
                    ref={register}
                  />
                </div>
              </div>

              <button
                className={styles.btnLink}
                style={{ marginLeft: "auto", marginBottom: "2rem" }}
                onClick={() => reset()}
              >
                Reset Fields
              </button>

              <button className={styles.contactSubmit}>
                Submit Application
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className={styles.careers}>
        <h2 className={styles.careersTitle}>Careers at Jenga</h2>

        <h3 className={styles.careersCategoryTitle}>Product</h3>
        <div className={styles.careersCategory}>
          <div>
            <h3>Product Manager</h3>
            <p>Entry Level Full Time</p>
          </div>
          <Link to="/join/product-manager" className={styles.btnPrimary}>
            Apply
          </Link>
        </div>
        <div className={styles.careersCategory}>
          <div>
            <h3>UI/UX Designer</h3>
            <p>Entry Level Full Time</p>
          </div>
          <Link to="/join/ui-ux" className={styles.btnPrimary}>
            Apply
          </Link>
        </div>
      </section>
    </Layout>
  )
}

export default JoinUs
